
<template>
  <div id="app">
    <app-header ref="header"></app-header>
    <div class="contents">
      <app-menu ref="menu"></app-menu>
      <router-view :key="$route.fullPath" class="gridArea" ref="view"></router-view>
    </div>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppMenu from './components/AppMenu.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppMenu,   
  },
  mounted: function() {
    window.vl = this;
  }
}
</script>

<style>
html,body,#app { height: 100%; }
@import url(//fonts.googleapis.com/earlyaccess/notosanskr.css);
* {
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans KR', sans-serif;
}
.contents {
  display: flex;
  flex-direction: row;
  height: 92vh;
}
.gridArea {
  flex-shrink: 0;
  flex-grow: 1;
}
.wrapGridArea { 
  padding: 0 20px;
}
.title:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 3px;
    background: #41b883;
    content: "";
}
.title {
    position: relative;
    margin: 30px 10px 30px 30px;
    padding-top: 5px;
    font-size: 13pt;
}
.grids {
  display: inline-block;
}
select {
  margin-bottom: 10px;
  text-align: center;
  width: 80px;
  height: 30px;
  border-radius: 5px;
  transition: 0.3s all;
  border-color: #ccc;
}
select:focus {
  outline: none !important; border-color: #8bdeb8; box-shadow: 0 0 10px #ccf7e4; 
}
button {
  padding: 7px 10px;
  margin: 0px 5px 20px 0px;
  border: 1px solid #ccc;
  background: none;
  border-radius: 3px;
  transition: 0.2s all;
}
button:hover {
  outline: none !important; border-color: #8bdeb8; box-shadow: 0 0 10px #ccf7e4; 
}
button:active {
  transition: 0s all;
  background: #42b883;
  color: white;
  outline: none !important; border-color: #428868; box-shadow: 0 0 30px #ccf7e4;
}
</style>
